import React from "react"
import Carousel from "@airasia/phoenix-widgets/widgets/Carousel"
import _ from "lodash"

export default function LocationCarousel(props) {
    // const cardData = []
  const cardData = props.data.map((location, index) => {
    return {
      attractText: "",
      chinaURL: "",
      cndisclaimerLine1: "",
      cndisclaimerLine2: "",
      companyName: "",
      companyURL: "",
      countDown: "",
      cta: "",
      currencyCode: "",
      discount: "",
      hidden: "",
      image: 'https://static.stgairasia.com/seo/static-assets/SEOFlightsImages'+location.image,
      imageAlt: `Flights to ${location.city}`,
      labelColor: "",
      location: "",
      mobileAppImageURL: "",
      newTab: "FALSE",
      position: "",
      price: "",
      priceClarification: "",
      priceDisclaimer: "",
      primaryLabel: "",
      productID: "",
      productType: "",
      rating: "",
      secondaryImage: "",
      secondaryLabel: "",
      star: "",
      subtitle: "",
      timer: "",
      title: location.city,
      url: location.link.href,
    }
  })

  return (
    <Carousel
      accessible
      cardConfig={{
        focusEffect: true,
      }}
      data={[...cardData]}
      heading={{
        cardCount: "5",
        gtmParameters: {
          event: "trackEventNoEcommerce",
          eventActionClick: "click",
          eventActionView: "view",
          eventCategory: "{{consumername}} | Flights Promotion",
          eventLabelCardClick:
            "Flights Promotion | {{user}} | {{order}} | {{cardtitle}} | {{productid}} | {{cardwidth}} | {{cardposition}} | {{redirecturl}}",
          eventLabelHeadlineClick:
            "Flights Promotion | {{user}} | headline | {{headline}}",
          eventLabelView: "Flights Promotion | {{user}} | {{order}}",
        },
        headline: "",
        layoutName: "lob_widget",
        showMoreURL: "",
        subHeadline: "",
        widgetID: "",
        widgetName: "Flights Location Widget",
        widgetWidth: "3",
      }}
      isLoading={_.isEmpty(props.data)}
      templateType="productCard"
      lazyLoadImage={true}
      enableProgressiveImageLoading={true}
    />
  )
}

